import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TComponent } from 'utils/types/component';

import styles from './BalanceInfo.module.scss';

interface IBalanceInfoProps {
    title: string;
    balanceInfo?: number;
    commissionInfo?: number;
    balanceDifference?: number;
    commissionTitle?: string;
}

export const BalanceInfo: TComponent<IBalanceInfoProps> = ({
    balanceInfo,
    commissionInfo,
    title,
    commissionTitle,
    balanceDifference,
}) => {
    const { t } = useTranslation();

    const isShowCommission = commissionInfo !== undefined;
    const isCurrentBalanceChanged =
        balanceDifference !== undefined && balanceDifference !== 0;

    let balanceChangeIcon = null;

    if (isCurrentBalanceChanged) {
        if (balanceDifference > 0) {
            balanceChangeIcon = (
                <span className={styles.balanceGrown}>
                    <CaretUpFilled />
                </span>
            );
        } else {
            balanceChangeIcon = (
                <span className={styles.balanceDecreased}>
                    <CaretDownFilled />
                </span>
            );
        }
    }

    return (
        <div className={styles.balanceInfo}>
            <Space direction='vertical'>
                <Typography.Text className={styles.balanceCount}>
                    {balanceInfo}
                    {balanceChangeIcon}
                </Typography.Text>
                <Typography.Text className={styles.subtitle} type='secondary'>
                    {t(title)}
                </Typography.Text>
            </Space>
            {isShowCommission ? (
                <Space direction='vertical' align='end'>
                    <Typography.Text className={styles.balanceCount}>
                        {commissionInfo}
                    </Typography.Text>
                    <Typography.Text
                        className={styles.subtitle}
                        type='secondary'
                    >
                        {t(commissionTitle || 'balance.tabs.commission')}
                    </Typography.Text>
                </Space>
            ) : null}
        </div>
    );
};
